import { createContext } from "react";

export const ErrorContext = createContext({
    error: null,
    message: null,
    setError: () => {},
    setMessage: () => {},
});